import { render, staticRenderFns } from "./TabsContent1.vue?vue&type=template&id=1559b574&scoped=true"
import script from "./TabsContent1.vue?vue&type=script&lang=js"
export * from "./TabsContent1.vue?vue&type=script&lang=js"
import style0 from "./TabsContent1.vue?vue&type=style&index=0&id=1559b574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1559b574",
  null
  
)

export default component.exports